import * as React from 'react';
export const arrowUpDownSvg = React.forwardRef(function ArrowUpDownSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: "M6.03091 4.66406C6.35428 4.40537 6.82681 4.458 7.0856 4.78124C7.34435 5.1047 7.29186 5.57718 6.96841 5.83593L4.46841 7.83593C4.19451 8.05492 3.80476 8.05499 3.53091 7.83593L1.03091 5.83593C0.707704 5.57716 0.655127 5.10461 0.913721 4.78124C1.17242 4.45788 1.64497 4.40551 1.96841 4.66406L3.99966 6.28906L6.03091 4.66406Z",
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: "M3.63833 0.0927679C3.90006 -0.0512708 4.22861 -0.0276259 4.46841 0.164057L6.96841 2.16406C7.29186 2.42281 7.34435 2.89529 7.0856 3.21874C6.82682 3.54206 6.35431 3.59464 6.03091 3.33593L3.99966 1.71093L1.96841 3.33593C1.64497 3.59454 1.17244 3.54213 0.913721 3.21874C0.65518 2.89536 0.707675 2.42279 1.03091 2.16406L3.53091 0.164057L3.63833 0.0927679Z",
    }),
  );
});
arrowUpDownSvg.defaultProps = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
export var arrowUpDown = {
  category: 'icon',
  colorable: true,
  name: 'arrowUpDown',
  svg: arrowUpDownSvg,
};
